import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "react-i18next";
import "../shared/quiz-style-context.js";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../context/DevToolsContext.js";
import { formatProblem } from "../../../utils/quiz-parser.js";
import { getImageUrl, getPrintScale, PRINT_CORRECT_ANSWER_CLASS, getStyles, PrintQuizTitle, PrintQuizImage } from "./print-common.js";
import { parseSelectTextOptionModels } from "../hooks/use-select-text-quiz.js";
function SelectTextPrint({
  quizId,
  quiz,
  number,
  showCorrectAnswers = false,
  correctAnswers,
  compact
}) {
  const s = getStyles(compact);
  const imageUrl = getImageUrl(quiz.image, quiz.imagePrint);
  const printScale = getPrintScale(quiz.image, quiz.imagePrint);
  const renderedProblem = formatProblem(
    quiz.problem,
    `${quizId}-print-problem`,
    (index, content) => {
      const options = parseSelectTextOptionModels(content).filter((option) => option.isSelectable);
      const correctIdx = (correctAnswers == null ? void 0 : correctAnswers[index]) != null ? parseInt(correctAnswers[index]) : 0;
      return /* @__PURE__ */ jsx(
        "span",
        {
          className: cn(
            s.inputBoxSm,
            "inline-flex items-center align-middle",
            compact ? "px-[10px] py-[8px] mx-[4px] my-[4px]" : "px-[16px] py-[8px] mx-[12px]"
          ),
          children: options.map((option, visibleIndex) => {
            const isCorrect = option.rawIndex === correctIdx;
            return /* @__PURE__ */ jsxs("span", { className: "flex items-center", children: [
              visibleIndex > 0 && /* @__PURE__ */ jsx("span", { className: "text-[#ccc] mx-[12px]", children: "/" }),
              /* @__PURE__ */ jsx(
                "span",
                {
                  className: cn(
                    compact ? "text-[15px] tracking-[-0.09px]" : "text-[16px] tracking-[-0.096px]",
                    showCorrectAnswers && isCorrect ? PRINT_CORRECT_ANSWER_CLASS : "text-black"
                  ),
                  children: /* @__PURE__ */ jsx(KatexText, { text: option.label })
                }
              )
            ] }, option.rawIndex);
          })
        },
        `select-print-${quizId}-${index}`
      );
    },
    quiz.additionalImages ?? void 0
  );
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    imageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: imageUrl, printScale }),
    /* @__PURE__ */ jsx("div", { className: s.problemArea, children: /* @__PURE__ */ jsx("div", { className: cn(
      s.problemLine,
      compact ? "text-[16px] text-black tracking-[-0.096px] font-normal leading-[41px]" : s.problemText
    ), children: renderedProblem }) })
  ] });
}
export {
  SelectTextPrint
};
//# sourceMappingURL=select-text-print.js.map
